import { Navigate } from "react-router-dom";

import { useAuth } from "@/hooks/useAuth";

export function RootRedirect(): JSX.Element {
  const auth = useAuth();
  if (!auth.accessToken) return <Navigate to="/login" replace />;
  if (auth.scope === "platform") return <Navigate to="/platform" replace />;
  return <Navigate to="/home" replace />;
}
